// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 请求接口地址 如果没有配置自动获取当前网址路径
var VUE_APP_API_URL = process.env.VUE_APP_BASE_API || "".concat(location.origin);
var VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || (location.protocol === 'https' ? 'wss' : 'ws') + ':' + location.hostname;
function removeTrailingSlash(url) {
  return url ? url.replace(/\/+$/, '') : url;
}
function resolveApiBaseUrl(baseUrl) {
  if (!baseUrl) {
    return "".concat(location.origin, "/api/");
  }
  if (/^https?:\/\//i.test(baseUrl)) {
    return "".concat(removeTrailingSlash(baseUrl), "/api/");
  }
  return baseUrl.endsWith('/') ? baseUrl : "".concat(baseUrl, "/");
}
var SettingMer = {
  // 服务器地址
  httpUrl: VUE_APP_API_URL,
  // 接口请求地址
  apiBaseURL: resolveApiBaseUrl(VUE_APP_API_URL),
  // socket连接
  wsSocketUrl: VUE_APP_WS_URL
};
export default SettingMer;